import { hasPackage } from './entitlements';
import { VISIT_MANAGER_PACKAGE_KEY } from '../admin/components/AdminPlanConfigConstants';

/** Setup sidebar + route: Visit Manager package + (Product Builder or explicit setup allowlist item). */
export function canShowVisitMobileConfigInSetup(
  productBuilderMode,
  allowedSetupItems
) {
  if (!hasPackage(VISIT_MANAGER_PACKAGE_KEY)) return false;
  if (productBuilderMode) return true;
  if (!allowedSetupItems) return false;
  const items =
    allowedSetupItems instanceof Set
      ? allowedSetupItems
      : new Set(
          (allowedSetupItems || []).map(item => String(item).toLowerCase())
        );
  return items.has('visit-mobile-config');
}
